import React from 'react';
import styled from 'styled-components';

import { VisuallyHidden } from 'shared/components/visually-hidden';
import { PlusIcon } from 'src/assets/plus';

import { useOptionContext } from './option-context';

/** Plus-circle add-to-cart icon shown on each option tile. */
export function TileAddIcon(): JSX.Element {
  const { label } = useOptionContext();

  return (
    <IconWrapper>
      <VisuallyHidden>Add {label} to cart</VisuallyHidden>
      <PlusIcon height={10} width={10} />
    </IconWrapper>
  );
}

const IconWrapper = styled.span`
  align-items: center;
  background: var(--dct--customized-colors-buttonsLinks);
  border-radius: 50%;
  color: var(--dcm-color-text-inverted, #fff);
  display: flex;
  height: 20px;
  justify-content: center;
  position: absolute;
  right: -6px;
  top: -6px;
  width: 20px;
`;
